function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3A5C",
  fillRule: "evenodd",
  d: "M16.5.197c.322.201.531.537.575.909l.008.14-.002 10.734c.003.426-.212.823-.57 1.054-.681.445-1.15.122-2.296-.417a18.259 18.259 0 00-7.125-2.058 5.24 5.24 0 002.9 4.517.834.834 0 11-.74 1.493 6.927 6.927 0 01-3.825-5.844l-.008-.267V3.286c0-.221.172-.404.393-.417a18.732 18.732 0 008.418-2.24C15.276.125 15.805-.245 16.5.197zM3.75 2.927c.205 0 .375.148.41.343l.007.074v6.674a.418.418 0 01-.342.41l-.075.006h-.812a2.916 2.916 0 01-2.925-2.73l-.005-.172L0 5.865A2.922 2.922 0 012.734 2.94l.172-.006.844-.006zm14.76 1.806a.42.42 0 01.382-.051c.66.235 1.104.86 1.108 1.56v.838a1.668 1.668 0 01-1.102 1.572.42.42 0 01-.381-.05.42.42 0 01-.178-.34l-.006-3.188c0-.135.066-.263.177-.341z"
});

function SvgMegaPhoneIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17
  }, props), _ref);
}

export default SvgMegaPhoneIcon;